import React from 'react'
import { withRouter } from 'react-router'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AccountUserDetailUI from '../../components/accountUser/AccountUserDetailUI'
import AccountUserDeleteModalUI from '../../components/accountUser/AccountUserDeleteModalUI'
import AccountUserUpdateModalUI from '../../components/accountUser/AccountUserUpdateModalUI'

const AccountUserDetailPageUI = ({context, messageList, accountUser,
  }) =>
  <PrivatePageSF context={context} className='pg_acc_user' backLink='/settings/members'
    messageList={messageList} headerMessageKey='c_user'
    centered={!accountUser}
  >
    {
      !accountUser &&
      <SpinnerComponentUI />
    }
    {
      accountUser &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/members'
          messageList={messageList} titleMessageKey='c_user'
        />
        <AccountUserDetailUI
          context={context}
          accountUser={accountUser}
          messageList={messageList}
        />
      </div>
    }

  </PrivatePageSF>

export default withRouter(AccountUserDetailPageUI)
